export const emptySelection: ReadonlySet<number> = new Set();

export const withTraderToggled = (
  current: ReadonlySet<number>,
  traderId: number,
): ReadonlySet<number> =>
  current.has(traderId)
    ? new Set([...current].filter((id) => id !== traderId))
    : new Set([...current, traderId]);

export const withTradersSelected = (
  current: ReadonlySet<number>,
  traderIds: readonly number[],
  selected: boolean,
): ReadonlySet<number> =>
  selected
    ? new Set([...current, ...traderIds])
    : new Set([...current].filter((id) => !traderIds.includes(id)));
